//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import Cuid from '@models/Cuid';
import DraftId from '@models/DraftId';
import PostableId from '@models/PostableId';
import { isDefined } from '@utils/filterPredicates';

import {
  StringifiedStateParams,
  deserializeOptionalEnumParam,
  deserializeOptionalNumericalParam,
} from 'app/initialization/routing/stateParamModels';

export const deserializeSchedulerParams = ({
  copiedDraftId: serializedCopiedDraftId,
  copiedScheduledPostId: serializedCopiedPostId,
  draftPostId: serializedDraftId,
  postTimeMs: serializedPostTimeMs,
  postType: serializedPostType,
  scheduledPostId: serializedPostId,
  targetCuid: serializedTargetCuid,
}: StringifiedStateParams<'schedule.scheduler'>) => {
  return {
    copiedDraftId: deserializeOptionalNumericalParam<DraftId>(
      serializedCopiedDraftId,
    ),
    copiedScheduledPostId: deserializeOptionalNumericalParam<PostableId>(
      serializedCopiedPostId,
    ),
    editDraftId: deserializeOptionalNumericalParam<DraftId>(serializedDraftId),
    editPostId: deserializeOptionalNumericalParam<PostableId>(serializedPostId),
    initialCuid: isDefined(serializedTargetCuid)
      ? Cuid(serializedTargetCuid)
      : undefined,
    initialPostTimeMs: deserializeOptionalNumericalParam(serializedPostTimeMs),
    postType: deserializeOptionalEnumParam(
      UniversalPostType,
      serializedPostType,
    ),
  };
};

const SECONDS_TO_MILLISECONDS_CONVERSION_FACTOR = 1000;
export const getThumbnailOffsetInSeconds = (offsetInMs: number = 0) =>
  offsetInMs / SECONDS_TO_MILLISECONDS_CONVERSION_FACTOR;
